/** Tipos de seção da home customizada (TipoSecaoHome no backend). */
export enum HomeSectionType {
    Banners = 1,
    DiarioOficial = 2,
    Noticias = 3,
    TextoLivre = 4,
    AcessoRapido = 5,
    CardDestaque = 6,
    Videos = 7,
    GaleriaImagens = 8
}

export interface IPortalHomeSectionItemResponse {
    id: number,
    sectionId: number,
    title: string | undefined,
    description: string | undefined,
    url: string | undefined,
    image: string | undefined,
    imageUrl: string | undefined,
    icon: string | undefined,
    openInNewTab: boolean,
    order: number
}

export interface IPortalHomeSectionResponse {
    id: number,
    type: HomeSectionType,
    title: string | undefined,
    subtitle: string | undefined,
    content: string | undefined,
    itemsQuantity: number | undefined,
    configuration: string | undefined,
    order: number,
    isFixed: boolean,
    items: IPortalHomeSectionItemResponse[] | undefined
}

export interface IPortalHomeResponse {
    /** false quando a entidade não customizou a home (ou não há seções): o portal mantém a home padrão. */
    isCustomized: boolean,
    sections: IPortalHomeSectionResponse[] | undefined
}
